import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { ItemType } from "./configTypes";

export default function useItemTypes() {
    const [itemTypes, setItemTypes] = useState<ItemType[]>([]);

    const getItemTypes = async () => {
        const res = await apiClient.get(`/inventory-dev/item-types`);
        setItemTypes(res.data);
    };

    useEffect(() => {
        getItemTypes();
    }, []);

    const createItemType = async (departmentId: number, name: string, code?: string) => {
        const res = await apiClient.post(`/inventory-dev/item-types`, { departmentId, name, code });
        setItemTypes((prev) => [...prev, res.data]);
        return res.data as ItemType;
    };

    const deleteItemType = async (id: number) => {
        await apiClient.delete(`/inventory-dev/item-types/${id}`);
        setItemTypes((prev) => prev.filter((t) => t.id !== id));
    };

    return { itemTypes, getItemTypes, createItemType, deleteItemType };
}
